import "assets/styles.css"
import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { ThemeProvider } from "styled-components"
import GlobalStyle from "client/theme/global"
import { DarkTheme } from "client/theme/darkTheme"
import { store } from "client/store"
import Main from "client/parts/main"

const Root = () => (
    // TODO: switch themes
    <Provider store={store}>
        <ThemeProvider theme={DarkTheme}>
            <GlobalStyle />
            <Main />
        </ThemeProvider>
    </Provider>
)
ReactDOM.render(<Root />, document.getElementById("root"))
